import script from "./section-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./section-modal.vue?vue&type=script&setup=true&lang=js"

import "./section-modal.vue?vue&type=style&index=0&id=53d232a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d232a2"]])

export default __exports__